import InterestModel from "./InterestModel";

export default class FullInterestModel extends InterestModel {
  model: any = null;
}
